export default __webpack_public_path__ + "static/media/exkal-vectorial-w.50a80e60.svg";